import { IconDownload, IconTrash, IconUpload } from "@tabler/icons-react"
import { ButtonWithMenu, ButtonWithMenuProps } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export type CatalogActionsMenuProps = {
  selectedProductIds: string[]
  onProductExportClick: () => void
  isProductExportLoading: boolean
  onProductsDeleteClick: () => void
  isProductsDeleteLoading: boolean
}

export const CatalogActionsMenu = ({
  selectedProductIds,
  onProductExportClick,
  onProductsDeleteClick,
  isProductsDeleteLoading,
  isProductExportLoading,
}: CatalogActionsMenuProps) => {
  const { t } = useTranslation(["common", "products"])

  const isLoading = useMemo(() => {
    return isProductExportLoading || isProductsDeleteLoading
  }, [isProductExportLoading, isProductsDeleteLoading])

  const items = useMemo<ButtonWithMenuProps["items"]>(() => {
    const result = [
      {
        icon: <IconDownload />,
        label: `${t("common:actionButtons.export")}`,
        onClick: onProductExportClick,
      },
      {
        icon: <IconTrash />,
        label: `${t("products:bulkActions.delete.action.name", { count: selectedProductIds.length })}`,
        onClick: onProductsDeleteClick,
        disabled: selectedProductIds.length === 0,
      },
      {
        icon: <IconUpload />,
        label: `${t("products:bulkActions.import.actionName")}`,
        onClick: () => window.open("/data-transfer/import", "_blank"),
      },
    ]

    return result
  }, [onProductExportClick, onProductsDeleteClick, selectedProductIds, t])

  return (
    <ButtonWithMenu loading={isLoading} items={items} disabled={isLoading}>
      {t("products:bulkActions.title")}
    </ButtonWithMenu>
  )
}
